var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremiumTemplates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1144 15.3942L32.1189 15.2156C31.0397 20.4669 28.2355 22.3478 24.9183 22.2452C21.601 22.3478 18.8006 20.4669 17.7214 15.2156L16.7259 15.3942C18.1736 26.0336 10.5208 27.3028 9.07312 15.7742L10.1599 25.779H39.6804L40.7634 15.7742C39.3157 27.3028 31.6667 26.0336 33.1144 15.3942Z",
    fill: "url(#paint0_linear_508_23008)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.22 15.5766C37.8679 27.3028 26.6358 26.0337 25.5148 13.2968H24.3217C23.1818 26.0337 11.9724 27.3028 9.61649 15.5766L8.80334 15.8008L10.1599 35.4799H39.6766L41.037 15.8008L40.22 15.5766Z",
    fill: "url(#paint1_linear_508_23008)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9221 38.2652C33.0729 38.2652 39.6805 37.0182 39.6805 35.48C39.6805 33.9417 33.0729 32.6947 24.9221 32.6947C16.7713 32.6947 10.1637 33.9417 10.1637 35.48C10.1637 37.0182 16.7713 38.2652 24.9221 38.2652Z",
    fill: "url(#paint2_linear_508_23008)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99332 16.9598C9.81806 16.9598 10.4866 16.2912 10.4866 15.4665C10.4866 14.6417 9.81806 13.9731 8.99332 13.9731C8.16858 13.9731 7.5 14.6417 7.5 15.4665C7.5 16.2912 8.16858 16.9598 8.99332 16.9598Z",
    fill: "#CD7714"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0337 15.9376C17.8585 15.9376 18.527 15.269 18.527 14.4443C18.527 13.6196 17.8585 12.951 17.0337 12.951C16.209 12.951 15.5404 13.6196 15.5404 14.4443C15.5404 15.269 16.209 15.9376 17.0337 15.9376Z",
    fill: "#B46100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8066 15.9376C33.6313 15.9376 34.2999 15.269 34.2999 14.4443C34.2999 13.6196 33.6313 12.951 32.8066 12.951C31.9818 12.951 31.3132 13.6196 31.3132 14.4443C31.3132 15.269 31.9818 15.9376 32.8066 15.9376Z",
    fill: "#B46100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9221 15.4665C25.9714 15.4665 26.822 14.6159 26.822 13.5666C26.822 12.5173 25.9714 11.6667 24.9221 11.6667C23.8728 11.6667 23.0222 12.5173 23.0222 13.5666C23.0222 14.6159 23.8728 15.4665 24.9221 15.4665Z",
    fill: "#F5C65C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.847 16.9598C41.6717 16.9598 42.3403 16.2912 42.3403 15.4665C42.3403 14.6417 41.6717 13.9731 40.847 13.9731C40.0222 13.9731 39.3536 14.6417 39.3536 15.4665C39.3536 16.2912 40.0222 16.9598 40.847 16.9598Z",
    fill: "#CD7714"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_508_23008",
    x1: 24.9182,
    y1: 27.6675,
    x2: 24.9182,
    y2: 21.0977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#733E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B46100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_508_23008",
    x1: 8.80334,
    y1: 24.3883,
    x2: 41.037,
    y2: 24.3883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7514"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F5C65C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D98B1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_508_23008",
    x1: 24.9221,
    y1: 39.7775,
    x2: 24.9221,
    y2: 29.5447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#733E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B46100"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumTemplates);
export default __webpack_public_path__ + "static/media/premium_templates.5b096fb2.svg";
export { ForwardRef as ReactComponent };